module.exports = __webpack_public_path__ + "img/1cube to 1bakkie.0df3733c.svg";